<template>
	<div id="box">
		<div id="container">
			<myhead></myhead>
			<main>
				<h4>验证您的企业身份</h4>
				<h6>
					<p>电子签署功能只能面向认证后的企业用户开放，为了不影响您的正常使用，您需要进行企业认证，</p>
					<p>并在企业认证完成后，设置公司印章。</p>
				</h6>
				<div class="tabs">
					<div class="tab">
						<div class="bg"></div>
						<h5>线上实名认证</h5>
						<div class="p">
							<p>填写您公司注册信息，我们将对</p>
							<p>您的公司进行线上的实名认证。</p>
						</div>
						<button class="btn subbtn" @click="onLine">认证</button>
					</div>
					<div class="tab">
						<div class="bg"></div>
						<h5>线下实名认证</h5>
						<div class="p">
							<p>如果您正在跟我们的销售顾问或营销商沟通，您可</p>
							<p>以留下销售顾问的联系方式进行线下的实名认证。</p>
						</div>
						<button class="btn subbtn" @click="offline">认证</button>
					</div>
				</div>
				<div class="skip">
					<span @click="onhome">暂时跳过，直接进入嗖嗖人力服务平台系统></span>
				</div>
			</main>
			<myfoot></myfoot>
		</div>
	</div>
</template>

<script>
	
	export default {
		name: 'CompanyId',
		
		data() {
			return {
				id:'',
				name:'',
			}
		},
		methods: {
			loadCurrentCompanyInfo() {
				axios.get('/settings/loadCompanyInfo').then(res => {
					this.id = res.data.data.id;
					this.name = res.data.data.company_name;
				})
			},
			
			onLine(){
        this.$router.push({path:'/licenceCllect?id='+this.$route.query.id+'&name='+ this.$route.query.name})
			},
			
			offline(){
        this.$router.push({path:'/realName?id='+this.$route.query.id+'&name='+ this.$route.query.name})
			},
			
			onprimary() {
				
			},
			onadvanced(){
				
			},
			onoffline(){
				this.$confirm('因部分业务功能只面向认证后的企业用户开放，为了不影响您的正常使用，请尽快联系您的销售顾问协助您完成企业身份验证，后续，您可在嗖嗖人力个人中心【企业设置】相关界面中查看提交您的企业身份认证状态。', '提示', {
					confirmButtonText: '我知道了',
					showCancelButton:false,
					iconClass:"el-icon-primary"
				}).then(() => {
					
				});
			},
			
			onhome(){
				this.$router.push({
					path: '/main',
				})
			}
		},
		mounted() {
			// this.loadCurrentCompanyInfo();
		},
	}
</script>

<style scoped lang="less">
	#app {
		position: relative;
	}
	
	#box {
		width: 100%;
		min-width: 1184px;
		background-color: #292b52;
		position: absolute;
		top: 0;
		bottom: 0;
		overflow: auto;
		#container {
			width: 1184px;
			margin: 0 auto;
			main {
				width: 100%;
				height: 560px;
				background-color: #fff;
				border-radius: 6px;
				display: flex;
				flex-direction: column;
				align-items: center;
				padding-top: 40px;
				box-sizing: border-box;
				h4 {
					font-size: 24px;
					font-weight: bolder;
				}
				h6 {
					font-size: 12px;
					margin-top: 10px;
					margin-bottom: 25px;
					text-align: center;
				}
				.tabs {
					width: 100%;
					height: 340px;
					display: flex;
					justify-content: center;
					.tab{
						width: 50%;
						height: 100%;
						box-sizing: border-box;
						position: relative;
						display: flex;
						align-items: center;
						justify-content: center;
						flex-direction: column;
						.bg{
							width: 168px;
							height: 156px;
							background-size: 168px 156px;
							background-position: center;
							background-repeat: no-repeat;
						}
						
						h5{
							font-size: 18px;
							font-weight: bold;
							margin: 20px 0;
						}
						
						.p{
							font-size: 12px;
							color: #9393a2;
							margin-bottom: 20px;
						}
						
						button{
							width: 84px;
						}
					}
					
					.tab:first-child{
						.bg{
							background-image: url(../../../assets/img/advanced.png);
						}
					}
					
					.tab:first-child:after{
						content: "";
						display: block;
						width: 1px;
						height: 80%;
						background-color: #d9dbe2;
						position: absolute;
						right: 0;
						top: 10%;
					}
					
					.tab:last-child{
						.bg{
							background-image: url(../../../assets/img/offline.png);
						}
					}
				}
				.skip {
					width: 100%;
					height: 80px;
					line-height: 80px;
					text-align: center;
					span {
						font-size: 16px;
						color: #6669e3;
						cursor: pointer;
					}
				}
			}
		}
	}
	
	@media (min-height:720px) {
		#container {
			width: 1184px !important;
			height: 720px;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto !important;
		}
	}
</style>
